<template>
  <template v-for="item in items" :key="item.id">
    <!-- 如果有子菜单 -->
    <el-sub-menu v-if="item.children && item.children.length > 0" :index="item.id + ''">
      <template #title>
        <el-icon v-if="collapse">
          <Menu />
        </el-icon>

        <span>{{ item.name }}</span>
      </template>
      <ProductTypeSubMenuItem :items="item.children" :collapse="collapse"/>
    </el-sub-menu>

    <!-- 如果是叶子节点 -->
    <el-menu-item v-else :index="item.id + ''">
      <el-icon v-if="collapse">
        <Menu />
      </el-icon>
      <span>{{ item.name }}</span>
    </el-menu-item>
  </template>
</template>

<script setup lang="ts">
import { ProductTypes } from '@/typeDefine/EntityType';
import { defineProps } from 'vue'

defineProps<{
  items: ProductTypes[]
  collapse: boolean
}>()
</script>
